import { useEffect, useState } from 'react';
import { api } from '../api';
import { message, ResourceError, useResource } from '../ui/hooks';

/** The tutor's running note about you (Ari's USER.md): it reads it every turn and rewrites it as it learns. */
export function NotesSettings() {
  const notes = useResource(api.notes, 'notes');
  const [text, setText] = useState(''), [saved, setSaved] = useState(''), [busy, setBusy] = useState(false), [error, setError] = useState<string | null>(null);
  useEffect(() => { if (notes.data) { setText(notes.data.text); setSaved(notes.data.text); } }, [notes.data]);
  async function save() {
    setBusy(true); setError(null);
    try { const next = await api.saveNotes(text); setText(next.text); setSaved(next.text); } catch (reason) { setError(message(reason)); } finally { setBusy(false); }
  }
  return <section className="settings-section"><h2>What the tutor knows about you</h2>
    <p className="muted">A plain note the tutor reads on every turn and rewrites when an exercise teaches it something about how you learn. Edit it freely.</p>
    {notes.error ? <ResourceError error={notes.error} retry={notes.reload} /> : <>
      <textarea className="notes-editor" rows={8} maxLength={4000} value={text} disabled={!notes.data || busy} placeholder="Nothing yet. It fills in as you work through exercises." onChange={e => setText(e.target.value)} />
      {error && <p className="error" role="alert">{error}</p>}
      <div className="actions"><button disabled={busy || text === saved} onClick={() => void save()}>Save note</button>{notes.data?.updatedAt && <small className="muted">Last changed {new Date(notes.data.updatedAt).toLocaleString()}</small>}</div>
    </>}
  </section>;
}
